import React, { FC, useCallback } from 'react'
import {
	FileWithPreview,
	IconComponent,
	PopoverComponent,
	UIPlacement,
	UISizes,
	UITrigger,
	UITypes,
} from 'LibNeo'
import { useAppDispatch } from 'Src/hooks'
import { formatDate, getActualSize, getFileNameAndExt, isImageFile } from 'Helpers'
import {
	FileExt,
	FileIcon,
	FileInfo,
	FileItemWrapper,
	FileLink,
	FileName,
	FileNameWrapper,
	FilePreview,
	FileWrapper,
	UploadPopoverOverlayStyled,
} from 'LibNeo/components/Basic/Upload/styled'
import { Callback } from 'Src/types/utilTypes'
import { modalsSlice } from 'Modules'

interface FileItemProps {
	file: Required<FileWithPreview>
	deleteFile?: Callback
	onViewFile: Callback
	loading: boolean
	isError: boolean
}

const getFileIcon = (loading: boolean, error: boolean) => {
	if (loading) return 'loader'
	if (error) return 'info'
	return 'attachment'
}

const getFileIconType = (loading: boolean, error: boolean) => {
	if (loading) return UITypes.PRIMARY
	if (error) return UITypes.DANGER
	return UITypes.GREY
}

const getFileLinkType = (loading: boolean, error: boolean) => {
	if (loading) return UITypes.PASSIVE
	if (error) return UITypes.DANGER
	return UITypes.PRIMARY
}

export const BgLimitRequestFileItem: FC<FileItemProps> = ({
	file,
	deleteFile,
	onViewFile,
	isError,
	loading,
}) => {
	const { showModal } = useAppDispatch({
		showModal: modalsSlice.actions.showModal,
	})

	const { fileName, ext } = getFileNameAndExt(file.name)

	const isImage = isImageFile(file.name)

	const viewFile = useCallback(
		(file: FileWithPreview) => () => {
			onViewFile(file)
		},
		[showModal]
	)
	const fileNameComponent = (
		<FileWrapper>
			<FileNameWrapper>
				<FileIcon
					name={getFileIcon(loading, isError)}
					size={UISizes.SMALL}
					type={getFileIconType(loading, isError)}
					onClick={viewFile(file)}
				/>
				<FileName notView={!file.preview}>
					<FileLink
						type={getFileLinkType(loading, isError)}
						title={fileName}
						onClick={viewFile(file)}
					/>
				</FileName>
				<FileExt>
					<FileLink
						type={getFileLinkType(loading, isError)}
						title={`.${ext}`}
						onClick={viewFile(file)}
					/>
				</FileExt>
			</FileNameWrapper>
			{!loading && (
				<FileInfo>
					{isError
						? 'Не удалось загрузить файл'
						: `${getActualSize(file.size)} • Загружен ${formatDate(
								file.created_at ?? new Date().toString()
						  )}`}
				</FileInfo>
			)}
		</FileWrapper>
	)

	return (
		<FileItemWrapper onClick={(e) => e.stopPropagation()} key={file.name}>
			{isImage && file.preview ? (
				<PopoverComponent
					trigger={UITrigger.HOVER}
					placement={UIPlacement.BOTTOM_LEFT}
					mouseEnterDelay={1}
					overlay={UploadPopoverOverlayStyled}
					content={
						<FilePreview withoutHeader>
							<img src={file.preview} alt={file.name} />
						</FilePreview>
					}
				>
					{fileNameComponent}
				</PopoverComponent>
			) : (
				fileNameComponent
			)}
			{deleteFile && !loading && (
				<IconComponent
					name="close"
					onClick={() => {
						deleteFile()
					}}
					type={UITypes.BLACK}
					size={UISizes.SMALL}
				/>
			)}
		</FileItemWrapper>
	)
}
